import { FiCheck } from 'react-icons/fi';
import { Icon, Text, VStack } from '@chakra-ui/react';

import { MobileFilterCard } from 'components/molecules/jobs/filters/mobile/card';
import { orderOptions } from 'lib/constants/order';
import { useJobFilters } from 'lib/repositories/jobsShowcaseFilters';

export const Order = () => {
  const { filters, setOrder } = useJobFilters();

  const orderSelectedLabel = orderOptions.find(
    (o) => o.value === filters.order
  );

  return (
    <MobileFilterCard
      isActive
      showTooltip={false}
      showResetFilter={false}
      label={orderSelectedLabel?.text || orderOptions[0].text}
      title='Ordenar por'
    >
      <VStack spacing={4} align='start'>
        {orderOptions.map((o) => {
          const isSelected = o.value === filters.order;

          return (
            <Text
              key={o.value}
              onClick={() => setOrder(o.value)}
              color={isSelected ? 'primary.500' : 'text.900'}
              fontSize={14}
              fontWeight={isSelected ? 700 : 400}
              display='flex'
              alignItems='center'
            >
              {o.text}

              {isSelected && (
                <Icon
                  as={FiCheck}
                  ml={2}
                  color={isSelected ? 'primary.500' : 'text.900'}
                  fontWeight={isSelected ? 700 : 400}
                />
              )}
            </Text>
          );
        })}
      </VStack>
    </MobileFilterCard>
  );
};
